import React, { useState } from 'react';
import Button from '@mui/material/Button';
import { InputNumber, Space, Row, Col, Segmented, Switch } from 'antd';
import Slider from '@mui/material/Slider';
import {BackspaceRounded} from "@mui/icons-material";
import {screenerFieldToName, ScreenerTypeIcon} from "./screensConfig";
import {stringMixin} from "../../utils/strings";




const QueryBuilder = ({ metrics, onAddFilter }) => {
  const [filterValues, setFilterValues] = useState(
    Object.keys(metrics).reduce((acc, key) => {
      // Initialize with a default condition and a single value, no range
      acc[key] = { condition: 'greater', value: 0 };
      return acc;
    }, {})
  );
  console.log(metrics);
  const handleConditionChange = (metric, newCondition) => {
      // Reset value when changing condition to ensure coherent user input
      setFilterValues(prev => ({
          ...prev,
          [metric]: { ...prev[metric], condition: newCondition, value: newCondition==='range'? [0, 100]:0, active: true }
      }));
      onAddFilter(metric, newCondition, [0], true); // Activate filter
  };

    const handleValueChange = (metric, newValue) => {
        setFilterValues(prev => ({
            ...prev,
            [metric]: { ...prev[metric], value: newValue, active: true }
        }));
        onAddFilter(metric, filterValues[metric].condition, newValue, true); // Update filter
    };

    const handleClearFilter = (metric) => {
        setFilterValues(prev => ({
          ...prev,
          [metric]: { condition: 'greater', value: 0, active: false }
        }));
        onAddFilter(null, null, null, false); // Clear filter by passing false
    };


  return (
    <Space direction={'vertical'} style={{maxHeight: '90vh', overflowY: 'auto'}}>
      {Object.keys(metrics).map((metric) => (
        <div key={metric} style={{ padding: '10px 0', borderBottom: '1px dashed #ddd' }}>
          <Row justify="space-between" align="middle">
            <Col span={14}>
              <span style={{fontFamily: 'var(--font-title)', fontSize: '12px', fontWeight: '500', textTransform: "uppercase"}}>
                <ScreenerTypeIcon type={metrics[metric].type} />
                {`${screenerFieldToName?.(metric)}`}
              </span>
            </Col>
           <Col style={{width: '40px'}}>
               <BackspaceRounded onClick={()=>handleClearFilter(metric)} style={{fontSize: '13px'}} />
           </Col>
          </Row>
          <Row gutter={8}>
            <Col span={8}>
              <Segmented
                defaultValue="greater"
                style={{ width: '100%' }}
                onChange={(newCondition) => handleConditionChange(metric, newCondition)}
                options={[
                  {
                    value: 'greater',
                    label: '>'
                  },
                  {
                    value: 'less',
                    label: '<'
                  },
                  {
                    value: 'range',
                    label: '| |'
                  }
                ]}
                size={'small'}
              />
            </Col>
            <Col span={8} offset={1}>
              <Slider
                range={filterValues[metric].condition === 'range'}
                value={filterValues[metric].value}
                onChange={(_, newValue) => handleValueChange(metric, newValue)}
                min={metrics[metric].min}
                max={metrics[metric].max} // This should be adjusted based on the actual data range of each metric
                step={metrics[metric]?.step ?? 1}
                size={'small'}
                marks={[
                    {value: metrics[metric].min, label: stringMixin.largeNumber(metrics[metric].min)},
                    {value: metrics[metric].max, label: stringMixin.largeNumber(metrics[metric].max)}
                ]}
              />
            </Col>
            <Col span={4} offset={1}>
              <InputNumber
                style={{ width: '100%', borderTop: 'none', borderRight: 'none', borderLeft: 'none' }}
                value={filterValues[metric].value}
                onChange={(value) => handleValueChange(metric, value)}
              />
            </Col>
          </Row>
        </div>
      ))}
    </Space>
  );
};

export default QueryBuilder;
